import React, { useEffect, useState } from "react";
import { Row, Col , Button } from "react-bootstrap";
import Spinner from "./shared/spinner";

// logos
import awardsLogo from '../../assets/SKELP_AwardsAch.svg';
import communityLogo from '../../assets/SKELP_CommInv.svg';
import educationLogo from '../../assets/SKELP_EducationTrain.svg';
import certificationsLogo from '../../assets/SKELP_CertsLicenses.svg';
import empHistoryLogo from '../../assets/SKELP_EmpHistory.svg';
import mediaLogo from '../../assets/SKELP_MediaRelations.svg';
import OnBehalfOfControl from "../../Components/onBehalfOfControl";


const SkillsLanding = ({ userName, setLocation, setMenuOptions, status, loadOboControl, loadPreviousProjects }) => {
    const [wizardMode, setWizardMode] = useState(false);
    const [loading, setLoading ] = useState(true);    
    useEffect(() => {
        if (status == null || status == undefined || status?.completed ==  false){
            setWizardMode(true);
        }

        setMenuOptions("SkillsLanding");
        setLoading(false);
    }, []);

    const handleClick = () => {
        setLocation("/Skills/education");
    };

    const WizardMode = ()=> (
        <>
        <Row className="my-4">
                <Col className="text-center">
                    <h1 className="cds-text-light">
                        Welcome to Skills & Experience
                    </h1>
                </Col>
            </Row>
            <Row className="my-4 justify-content-center">
                <Col className="text-center col-12 col-md-8 col-lg-6">
                    <p className="lead" style={{ lineHeight: "1.8" }}>
                        Completing your profile supports operations, sales, and pursuit efforts and plays a critical role in staffing 
                        successful projects. It also helps us better understand who we are as a company, including our backgrounds, 
                        experiences, and perspectives, and enables us to share our collective story effectively. After all, you are 
                        one of the best and brightest!
                    </p>
                </Col>
            </Row>
            <Row className="my-4">
                <Col className="text-center">
                    <button className="btn btn-primary" onClick={handleClick}>
                        Get Started
                    </button>
                </Col>
            </Row>
        </>
    );

    const handleTileClick = (link) => {
        setLocation(link.url);
    }
        
    const getTiles = () => {
        const options = new Array();

        options.push({
            url: '/Skills/education',
            image: educationLogo,
            title: 'Education & Training'
        });
        options.push({
            url: '/Skills/certifications',
            image: certificationsLogo,
            title: 'Certifications'
        });
        options.push({
            url: '/Skills/employment',
            image: empHistoryLogo,
            title: 'Employment History'
        });
        options.push({
            url: '/Skills/community',
            image: communityLogo,
            title: 'Community Involvement'
        });
        options.push({
            url: '/Skills/media',
            image: mediaLogo,
            title: 'Media Relations'
        });
        options.push({
            url: '/Skills/awards',
            image: awardsLogo,
            title: 'Awards & Achievements'
        });

        if (loadPreviousProjects) {
            options.push({
                url: '/Skills/previousProjects',
                image: empHistoryLogo,
                title: 'Previous Project Experience'
            });
        }

        return options;
    }

    const TileMode = () => (
        <>
         <Row className="mb-4">
                <Col className="text-center">
                    <h1>
                        Hello
                        {userName ? " " + userName : ""}!
                    </h1>
                </Col>
        </Row>
        <Row className="d-flex justify-content-center">
                {getTiles().map((link, i) => (
                    <Col className="col-12 col-md-3 mx-4 mb-5 text-center">
                        <img
                            onClick={() => handleTileClick(link)}
                            style={{cursor: 'pointer'}}
                            src={link.image}
                            className="w-50 mb-3 link-icon"
                            title={link.description}
                            data-toggle="tooltip"
                            data-placement="top"
                        />
                        <br/>
                        <b className="mb-5">{link.title}</b>
                    </Col>
                ))}
            </Row>
        </>
    );

    return (
        <div className="skills-landing">
            {loadOboControl ?         
            <OnBehalfOfControl>
                {
                    loading ?
                    <>
                    <Spinner/>
                    </>
                    :
                    wizardMode ?
                    <WizardMode/>
                    :
                    <TileMode/>
                }
            </OnBehalfOfControl> 
            :
            <div>
                {
                    loading ?
                    <>
                    <Spinner show={loading}/>
                    </>
                    :
                    wizardMode ?
                    <WizardMode/>
                    :
                    <TileMode/>
                }
            </div>
        }
        </div>
    );
};

export default SkillsLanding;
